enum ActionType {
  verifyInvitation = 'VERIFY_INVITATION',
  successToVerifyInvitation = 'SUCCESS_TO_VERIFY_INVITATION',
  failedToVerifyInvitation = 'FAILED_TO_VERIFY_INVITATION'
}

export default ActionType;

export enum ApplicantType {
  /** 兼任用（契約者代表と入居者が同一人物） */
  ContractorAndOccupant = 'ContractorAndOccupant',
  /** 入居者用 */
  Occupant = 'Occupant',
  /** 契約者用 */
  Contractor = 'Contractor'
}

export const getApplicantText = (applicantType: ApplicantType) => {
  switch (applicantType) {
    case ApplicantType.Contractor:
      return 'CONTRACTOR_ONLY';
    case ApplicantType.Occupant:
      return 'OCCUPANT_ONLY';
    case ApplicantType.ContractorAndOccupant:
      return 'CONTRACTOR_AND_OCCUPANT';
  }
};

export type verifyInvitationErrorStatus =
  | 'no_error'
  | 'invalid_request'
  | 'not_found'
  | 'locked'
  | 'already_applied'
  | 'canceled'
  | 'internal';

export const ALREADY_APPLIED_CODE = 'sumamoru-invitation-already-applied';
